import { render, staticRenderFns } from "./ApartmentComments.vue?vue&type=template&id=227fcc17&scoped=true"
import script from "./ApartmentComments.vue?vue&type=script&lang=js"
export * from "./ApartmentComments.vue?vue&type=script&lang=js"
import style0 from "./ApartmentComments.vue?vue&type=style&index=0&id=227fcc17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227fcc17",
  null
  
)

export default component.exports